"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderComposer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ComposerFragment = ({ children }) => (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
const providerReducer = (ParentProvider, ChildProvider) => ({ children }) => ((0, jsx_runtime_1.jsx)(ParentProvider, { children: (0, jsx_runtime_1.jsx)(ChildProvider, { children: children }) }));
/**
 * @Component
 * @name ProviderComposer
 * @description Component that receives a list of providers and composes them to a single component.
 */
const ProviderComposer = (props) => {
    const ComposedProviders = props.with.reduce(providerReducer, ComposerFragment);
    return (0, jsx_runtime_1.jsx)(ComposedProviders, { children: props.children });
};
exports.ProviderComposer = ProviderComposer;
